import { Component } from '@angular/core';

@Component({
  selector: 'app-accroche',
  imports: [],
  templateUrl: './accroche.component.html',
  styleUrl: './accroche.component.scss'
})
export class AccrocheComponent {

}
